export default __webpack_public_path__ + "static/media/alarm_classic.2d6ea896.mp3";